import _ from 'lodash'
import { removeZeroWidthStyleFromHTML } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import {
  INTERSECTION_DELIVERY_TYPES,
  SKIP_REQUIRED_FIELD,
  WARRANTY_SCOPE_OTHER,
  WARRANTY_PERIOD_NONE,
  OTHER_ATTRIBUTE_VALUE,
  ATTRIBUTE_CONSTRAINTS_TYPE,
  SPEC_SETTING_MODAL_FIELD_MIN_LENGTH,
  EDITOR_UPLOADER_MAX_IMAGE_WIDTH_SIZE,
  PROPOSAL_PHASE_TYPE,
  SPEC_ITEM_MAX_LENGTH,
  FIRST_SPEC_ITEM_MAX_LENGTH,
  RADIO_EVOUCHER_TYPES
} from '../../../../../constants/proposalTypes'
import { INVALID_TRANSIENT_KEY, TRANSIENT_FIELD_KEY, SHIP_TYPE_FORM_SECTION_NAME } from '../../../Shared'
import { INVALID_STYLES_IMG } from '../../../../Common/MCEEditor/shared'
import { isEmptyStr } from '../../../../../lib/Validator'
import { getHasAnyErrorFile } from '../../../../../lib/uploaderUtil'
import { groupDaysByDateType } from '../../../../../lib/dateUtil'
import { getUuid } from '../../../../../../lib/renderUtil'
import {
  PRODUCT_DELIVERY_TYPE,
  PROPOSAL_REVIEW_STATUS,
  PRODUCT_SHIP_TYPE,
  FIELD_MAX_NUM_VAL,
  FIELD_MAX_LENGTH,
  EXPIRING_NOTE,
  PROPOSAL_TYPE,
  BSMI_SPEC_NAMES
} from '@vzmi/shp_shared_compo/constants/proposal'
import { numberNormalizer, removeSpaceAndTab } from './normalizers'
import { getShipTypeIdFromAllValues, getPropposalTypeFromAllValues, getProductNameFromAllValues, getIsExpiringItemFromAllValues } from '../../../../../lib/ReduxFormSelectors/ProposalListingForm'
import { isNewListingProposal, isNewProductProposal } from '../../../../../../lib/proposalHelper'
import { showNoLessThan, showOnlyNumber } from '../../../../../lib/formatter'
import { MEDIA_UPLOADER_ID } from '../../../../../constants/formTypes'
import cheerio from 'cheerio'
import { getParsedTransientData } from './TransientDataUtil'

export const getScopedShipTypeSectionName = ({ shipType, namePrefix = SHIP_TYPE_FORM_SECTION_NAME }) => `${namePrefix}.shipType${shipType}`
export const getScopedShipTypeFieldName = (formSectionName, fieldName) => `${formSectionName}.${fieldName}`
export const getScopedFieldNameByShipType = (shipType, fieldName) => `${getScopedShipTypeSectionName({ shipType })}.${fieldName}`

export const calculateTotalVolume = ({ width = '', height = '', length = '' }) => {
  const dimensionsToNumber = [width, height, length]
    .map(oneDimension => numberNormalizer(oneDimension))
    .map(oneDimension => _.toNumber(oneDimension))

  return _.sum(dimensionsToNumber)
}
export const signedApplianceContract = (values) => _.get(values, 'setting.applianceContract', false)

export const hasIntersection = (deliveryTypes) => {
  const intersectedDeliveryTypes = _.intersection(INTERSECTION_DELIVERY_TYPES, deliveryTypes)
  return !_.isEmpty(intersectedDeliveryTypes)
}

export const getFormValues = (formState, field) => {
  return field ? _.get(formState, `values.${field}`, {}) : _.get(formState, 'values', {})
}

export const isNoneWarrantyPeriod = value => value === WARRANTY_PERIOD_NONE
export const isCustomWarranty = value => value && value === WARRANTY_SCOPE_OTHER

export const getSpecAttributeFieldPrefixByLevel = (hasSpecLevel = false) => {
  const specLevelKey = determineSpecLevel(hasSpecLevel).withSpecLevel
    ? 'with'
    : 'without'

  return `attributes.${specLevelKey}Level`
}

// { model: { spec: { }, displayName: undefined }, item: { displayName: undefined, spec: {}, index: undefined } }
export const getAttrTableRowKey = ({ model, item } = {}) => getUuid({ model, item })

export const getAttrTableFieldPrefixByLevel = (level = false) => {
  const { withSpecLevel } = determineSpecLevel(level)
  return `table.${withSpecLevel ? 'with' : 'without'}Level`
}

export const getAttrTableFullField = (subStationId, catItemId, struDataAttrClusterId, level) => {
  return `${getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)}.${getAttrTableFieldPrefixByLevel(level)}`
}
export const getSpecAttributeFullField = (subStationId, catItemId, struDataAttrClusterId, level) => {
  return `${getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)}.${getSpecAttributeFieldPrefixByLevel(level)}`
}

export const getSpecAttributeFieldByLevel = (level = false) => {
  return `${getSpecAttributeFieldPrefixByLevel(level)}`
}

export const getActiveTransientData = (allValues) => {
  const { subStationId, product = {} } = allValues
  const { catItemId, struDataAttrClusterId } = product
  if (subStationId && catItemId && struDataAttrClusterId) {
    const activeTransientField = `${getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)}`
    const activeTransientData = _.get(allValues, activeTransientField, null)
    if (activeTransientData) {
      return activeTransientData
    }
  }
  return {}
}

/**
 * 組出 redux-from setting 裡面的 `__transient__`
 */
export const setActiveTransientData = (setting = {}, formData) => {
  const candidateStruDataList = _.get(formData, 'candidateStruDataList', null)

  const candidateStruDataAttrClusterList = _.get(setting, 'candidateStruDataClusterList')

  const {
    mismatchedCluster
  } = setting

  const {
    subStationId,
    product = {}
  } = formData

  const {
    catItemId,
    struDataAttrClusterId
  } = product

  const mismatchedClusterId = _.get(mismatchedCluster, 'id', null)
  const MISMATCH_CLUSTER_TRANSIENT_PATH = 'setting.mismatchedCluster.transient'
  const phase = _.get(setting, 'phase')
  const currentActiveTransientField = mismatchedClusterId && phase === PROPOSAL_PHASE_TYPE.COMPOSE
    ? MISMATCH_CLUSTER_TRANSIENT_PATH
    : getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)

  if (
    (subStationId && catItemId && struDataAttrClusterId) ||
    !!mismatchedClusterId
  ) {
    const activeTransientData = getParsedTransientData(setting, formData)
    _.set(formData, currentActiveTransientField, activeTransientData)
  }

  /**
   * for updateAttribute,
   * 在有超過一組規格表的狀況下，
   * 每一組都要組出 transientData
   */
  if (candidateStruDataList) {
    candidateStruDataList.forEach((struData, idx) => {
      const activeTransientField = getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)
      const currentTransientData = _.get(formData, activeTransientField, null)

      if (_.isNull(currentTransientData)) {
        let {
          attributes,
          struDataAttrClusterId
        } = struData
        let struDataAttrCluster

        if (
          currentActiveTransientField === MISMATCH_CLUSTER_TRANSIENT_PATH &&
          _.size(candidateStruDataList) === 1
        ) {
          struDataAttrCluster = _.get(formData, MISMATCH_CLUSTER_TRANSIENT_PATH, null)
          attributes = _.get(struDataAttrCluster, 'attributes', [])
        } else {
          struDataAttrCluster = candidateStruDataAttrClusterList[idx]
        }

        const parsedTransientData = getParsedTransientData(
          _.merge(
            _.cloneDeep(setting),
            { struDataAttrCluster }
          ),
          _.merge(
            _.cloneDeep(formData),
            {
              product: {
                attributes,
                struDataAttrClusterId
              }
            }
          )
        )

        _.set(formData, activeTransientField, parsedTransientData)
      }
    })
  }

  return formData
}

export const hasDuplicateSpec = _.memoize((opts) => _.flow([
  (t) => _.groupBy(t, o => o.value),
  (t) => _.pickBy(t, x => x.length > 1),
  (t) => _.size(t)])(opts))

/**
 * 選擇規格表-商品屬性，兩層商品屬性
 * 取得賣場名稱長度限制 getProductNameExceedLength
 * 取得項目名稱長度限制 getSpecItemExceedLength
 * */
const noLessThan0 = showNoLessThan(0)
/** 取得第一層屬性用掉的字數長度 */
export const getLengthUsedByFirstLayer = (selectedItemOptions = []) =>
  selectedItemOptions
    .map(item => item.value)
    .reduce(
      (longestValueLength, itemValue) => _.max([
        longestValueLength,
        _.size(itemValue)
      ]),
      0 // default longestValueLength
    ) + 1 // plus 1 in the final for including "-"

/**
 * 獲得 specSettingModal 裡面，賣場名稱可以填寫的字數範圍
 *
 * lever2時要扣掉 level1 用掉的長度
 * 減去 1 是因為要把 `-`
 * 另外減去 SPEC_SETTING_MODAL_FIELD_MIN_LENGTH 因為需要限制spec modal內屬性項目最少需要輸入一個字
*/
export const getProductNameLengthMaxInSettingModal = (
  productNameLengthMax,
  level = 1,
  lengthUsedByFirstLayer = 0
) => {
  const dashLength = 1
  return noLessThan0(
    productNameLengthMax - SPEC_SETTING_MODAL_FIELD_MIN_LENGTH - dashLength - (
      level === 2
        ? lengthUsedByFirstLayer
        : 0
    )
  )
}

/**
 * 獲得 1 個 spec field 最多可以用的字數長度，
 * 因為需要限制spec modal內屬性項目最少需要輸入一個字，在取值的時候必須將這個缺失加回來
*/
export const getSpecItemExceedLength = (
  curProductNameLengthMax,
  level = 1,
  lengthUsedByFirstLayer = 0,
  curProductNameLength = 0
) => {
  const lengthMaxInSettingModal = getProductNameLengthMaxInSettingModal(curProductNameLengthMax, level, lengthUsedByFirstLayer) + SPEC_SETTING_MODAL_FIELD_MIN_LENGTH

  return noLessThan0(
    lengthMaxInSettingModal - curProductNameLength
  )
}

/**
 * 取得各層屬性項目上限個數
 */
export const getMaxSpecItemLen = (specLen, level) => {
  return specLen > 1 && level === 1
    ? FIRST_SPEC_ITEM_MAX_LENGTH.TWO_LAYER
    : SPEC_ITEM_MAX_LENGTH
}

/**
 * 取得各層排除超過個數上限的屬性項目
 * @param {Array} items 選擇選項
 * @param {Number} specLen 屬性層數
 * @param {Number} level 屬性層級
 */
export const getSlicedSpecItems = (items = [], specLen, level) => {
  return items.slice(0, getMaxSpecItemLen(specLen, level))
}

/**
 * 取 product.name 的長度限制，因為會隨是否為即期品而不同，
 * 所以需要另外用這個 function 來取
 */
export const getProductNameLengthMax = (showExpiringAddon, proposalType) => {
  if (typeof proposalType === 'undefined') {
    console.error('util.js:getProductNameLengthMax(): proposalType undefined') // APACSMDESK-44393 temp
  }
  const fieldName = isNewListingProposal(proposalType) ? 'LISTING_NAME' : 'PRODUCT_NAME'
  const defaultNameLength = getFieldLengthMaxByName(fieldName)
  return defaultNameLength - (showExpiringAddon ? EXPIRING_NOTE.STR.length : 0)
}

export const determineSpecLevel = (hasSpecLevel) => {
  const withSpecLevel = (
    hasSpecLevel === true ||
    hasSpecLevel === 'true'
  )
  const specLevelUndefined = _.isUndefined(hasSpecLevel)
  const withoutSpecLevel = !specLevelUndefined && !withSpecLevel
  return {
    specLevelUndefined,
    withSpecLevel,
    withoutSpecLevel
  }
}

export const containsWarehouseBarcode = (item = {}) => !!item.warehouseBarcode

export const presetRawProductData = (product = {}) => {
  const localProduct = { ...product }
  const tmpModels = localProduct.models || []
  const currentShareImageModel = _.find(tmpModels, o => o.shareImageModel === true)
  const regroupedModels = _.map(tmpModels, (model = {}, idx) => {
    const { images = [] } = model
    const isFirstModel = idx === 0
    const isShareImageModel = !_.isEmpty(currentShareImageModel) && isFirstModel
    return {
      ...model,
      // 只有單層屬性才有共用商品圖片功能
      shareImageModel: isShareImageModel,
      images: isShareImageModel ? _.get(currentShareImageModel, 'images', []) : images,
      items: _.map(model.items, (item = {}) => {
        return {
          ...item,
          hasWarehouseBarcode: containsWarehouseBarcode(item)
        }
      }) || []
    }
  }) || []
  _.set(localProduct, 'models', regroupedModels)
  _.isEmpty(currentShareImageModel) && _.set(localProduct, 'shareMediaBetweenModels', false)
  return localProduct
}

export const convertOptionToSpec = (level, opt = {}) => {
  return { level, name: opt.value }
}

const getSpecs = (specs) => {
  return _.compact(_.map(specs, (localSpec, specIdx) => convertOptionToSpec(specIdx + 1, localSpec.selectedOption)))
}
const getModelSpec = (opt, optItem) => {
  return { displayName: optItem.displayName, spec: { name: opt.label, values: optItem.values || [optItem.value] } }
}

export const getUuidByModelSpec = (model = { spec: {}, displayName: undefined }) => getUuid({ ..._.pick(model, ['spec', 'displayName']) })
export const convertRawDataToRenderingData = ({ rawProduct = {}, data, hasSpecLevel: originHasSpecLevel }) => {
  const { spec = [], product = {} } = data
  const shareMediaBetweenModels = rawProduct.shareMediaBetweenModels || false
  let expandedRowKeys = rawProduct.expandedRowKeys || []
  const rawModels = rawProduct.models || []
  const levels = spec.length
  let models = []
  let localProduct = product
  const errorImagesExpandedRowKeys = []
  const { withSpecLevel: hasSpecLevel } = determineSpecLevel(originHasSpecLevel)
  if (hasSpecLevel) {
    const { selectedOption = {}, selectedItemOptions = [] } = _.get(spec, 0, {})
    const uniqItemOptions = _.uniqBy(selectedItemOptions, (e) => {
      return e.value
    })
    models = _.map(uniqItemOptions, (specItem, idx) => {
      const secondLayer = _.get(spec, 1, {})
      const { selectedOption: secondOptions, selectedItemOptions: secondItemOptions } = secondLayer
      let returnModel = {}
      const modelSpec = getModelSpec(selectedOption, specItem)
      const modelUuid = getUuidByModelSpec(modelSpec)
      // pick up old data from rawProduct and merge to new model
      const foundModelItem = _.find(rawModels, rawModel => {
        const rawModelUuid = getUuidByModelSpec(rawModel)
        return modelUuid === rawModelUuid
      }) || {}
      const rowKey = getAttrTableRowKey({ model: { ..._.pick(modelSpec, ['spec', 'displayName']) }, item: { index: 0, ..._.pick(foundModelItem, ['spec', 'displayName']) } })
      const modelImages = foundModelItem.images
      const baseItem = { rowKey }
      // 一層時item沒有spec
      if (levels === 1) {
        // 一層時需要一個物件佔位
        if (!_.isEmpty(foundModelItem)) {
          _.set(foundModelItem, 'items[0].rowKey', rowKey)
          returnModel = {
            ...foundModelItem,
            ...modelSpec
          }
        } else {
          returnModel = {
            ...modelSpec,
            images: modelImages,
            items: [baseItem]
          }
        }
        // 只有單層才有共用商品圖片功能，如果開啟共用圖片而且第一個Model被刪除或者變動，則要將原始共用圖片複製過來
        // Fix the bug that shared image missing after model name changes
        if (idx === 0 && shareMediaBetweenModels) {
          const currentShareImageModel = _.find(rawModels, o => o.shareImageModel === true) || {}
          const shareImages = currentShareImageModel.images
          returnModel = {
            ...returnModel,
            images: shareImages || [],
            shareImageModel: true
          }
          // 如果Model變動時，若已有展開則清除原始圖片展開的Key，再預設展開第一個Model的共用圖片區塊
          const shareModelRowKey = _.get(returnModel, 'items[0].rowKey')
          expandedRowKeys = _.includes(expandedRowKeys, shareModelRowKey) ? [] : [shareModelRowKey]
        }
      } else if (levels === 2) {
        const uniqSecondItemOptions = _.uniqBy(secondItemOptions, (e) => {
          return e.value
        })
        returnModel = {
          ...modelSpec,
          images: modelImages,
          items: _.map(uniqSecondItemOptions, (innerItemOption, innerIdx) => {
            const innerItemSpec = getModelSpec(secondOptions, innerItemOption)
            const innerModelItemUuid = getUuidByModelSpec(innerItemSpec)
            // pick up old model item data from rawProduct and merge to new model item
            const foundInnerItem = _.find(_.get(foundModelItem, 'items', []), m => {
              const modelItemUuid = getUuidByModelSpec(m)
              return innerModelItemUuid === modelItemUuid
            }) || {}
            const key = getAttrTableRowKey({ model: { ..._.pick(modelSpec, ['spec', 'displayName']) }, item: { index: innerIdx, ..._.pick(innerItemSpec, ['spec', 'displayName']) } })
            const innerItem = {
              ...foundInnerItem,
              ...innerItemSpec,
              rowKey: key
            }
            return innerItem
          })
        }
      }

      // 重新組合表格圖片上傳區塊展開的Keys，要將錯誤的展開，不然沒辦法點擊展開
      if (!shareMediaBetweenModels && !_.isEmpty(modelImages) && getHasAnyErrorFile(modelImages)) {
        const imageRowKey = _.get(returnModel, 'items[0].rowKey')
        errorImagesExpandedRowKeys.push(imageRowKey)
      }
      return returnModel
    })
    localProduct = {
      shareMediaBetweenModels,
      expandedRowKeys: _.uniq([...expandedRowKeys, ...errorImagesExpandedRowKeys]),
      specs: getSpecs(spec),
      models
    }
    levels !== 1 && delete localProduct.shareMediaBetweenModels
  } else {
    localProduct = _.merge({}, localProduct, rawProduct)
    const models = _.map(_.get(localProduct, 'models', []), (model, idx) => {
      const modelImages = model.images
      let modelItems = _.get(model, 'items', [])
      // 如果items是空的而images不是空的，則產生一個空物件來佔位items
      if (_.isEmpty(modelItems)) {
        modelItems = [{}]
      }
      model.items = _.map(modelItems, (item, itemIdx) => {
        const rowKey = getAttrTableRowKey({ item: { index: itemIdx } })
        return {
          ...item,
          rowKey
        }
      })
      // 重新組合表格圖片上傳區塊展開的Keys，要將錯誤的展開，不然沒辦法點擊展開
      if (!_.isEmpty(modelImages) && getHasAnyErrorFile(modelImages)) {
        const imageRowKey = _.get(model, 'items[0].rowKey')
        errorImagesExpandedRowKeys.push(imageRowKey)
      }
      return model
    })
    localProduct = {
      ...localProduct,
      expandedRowKeys: _.uniq([...expandedRowKeys, ...errorImagesExpandedRowKeys]),
      models
    }
  }

  // preset product rendering options
  localProduct = presetRawProductData(localProduct)

  return localProduct
}

export const removeOTHERFromClusterValues = (c = {}) => {
  const clusterValues = _.get(c, 'values', [])
  const hasOTHER = _.findIndex(clusterValues, value => value === OTHER_ATTRIBUTE_VALUE) >= 0

  return ({
    ...c,
    // clusterValues 裡面是否有 '其他'
    hasOTHER,
    values: hasOTHER
      // 去除 '其他'
      ? _.filter(clusterValues, val => val !== OTHER_ATTRIBUTE_VALUE)
      : clusterValues
  })
}

// 預設將cluster values去除 "其他" 選項
export const convertClusterToAttributeOption = (c) => ({
  cluster: { ...removeOTHERFromClusterValues(c) },
  label: c.name,
  value: c.name
})

export const convertAttributeItemOptions = (selectedAttrOption = {}) => _.map(_.compact(_.get(removeOTHERFromClusterValues(selectedAttrOption.cluster), 'values', [])), o => ({ label: o, value: o + '', values: [o + ''] })) || []
export const makeItemOptions = (opts) => _.map(opts, (o, idx) => ({ ...o, key: `${o.displayName || o.value}_${idx}` }))
export const makeCustomItemOption = value => ({
  displayName: value,
  label: value,
  value,
  values: [OTHER_ATTRIBUTE_VALUE]
})
export const hasDuplicateAttribute = (attributes) => _.flow([
  (t) => _.groupBy(t, o => o.name),
  (t) => _.pickBy(t, x => x.length > 1),
  (t) => _.size(t)])(attributes) >= 1
export const isDraftStatus = ({ reviewStatus } = {}) => reviewStatus === PROPOSAL_REVIEW_STATUS.DRAFT
export const isComposingStatus = ({ reviewStatus } = {}) => reviewStatus === PROPOSAL_REVIEW_STATUS.COMPOSING
export const getProposalComposePath = proposalType => `/proposal/${proposalType}/compose`

export const isSkipRequired = (values) => _.get(values, SKIP_REQUIRED_FIELD, false)
// 儲存草稿的時候，除非該 Field 有值，不然不用進行 validation，
// 設定為 setting.skipRequired 為真時，Field 又沒有值的時候，validation 要略過
export const ableToSkipValidation = (value, allValues) => isEmptyStr(value) && isSkipRequired(allValues)

const BSMI_SPEC_NAMES_MAP = _.keyBy(BSMI_SPEC_NAMES)
export const getIsBSMIName = name => name in BSMI_SPEC_NAMES_MAP

/**
 * @param {number} shipType
 * @param {string} [amountType=''] 'msrp' or 'price' or 'cost'
 *
 * 配送方式為 “直店配(宅配+超取)” 時，
 * msrp 值需≤9,999,999
 * price, cost值需≤20,000，
 *
 * 其他配送方式，
 * msrp, price, cost 值皆需≤9,999,999
 */
export const getPriceCap = (shipType, amountType = '') => {
  const isMsrp = amountType === 'msrp'
  const isHomeStoreShip = isHomeStore(shipType)
  const priceCap = isHomeStoreShip && !isMsrp
    ? FIELD_MAX_NUM_VAL.PRICE_CAP_HOME_STORE
    : FIELD_MAX_NUM_VAL.PRICE_CAP

  return priceCap
}

/**
 * ˋ是否為 "直店配(宅配+超取)"
 */
export const isHomeStore = (shipType = '') => shipType === PRODUCT_SHIP_TYPE.HOME_STORE

/** compose form **/
export const omitFormSettingFields = (formValues) => {
  return _.omit(formValues, [
    INVALID_TRANSIENT_KEY,
    TRANSIENT_FIELD_KEY,
    SHIP_TYPE_FORM_SECTION_NAME,
    'mustShowFormError',
    'setting'
  ])
}

export const omitAttributeTableItem = (item, originShipTypeId, isNewListing, entireProductName, warehouseProductNameCountLimit) => {
  const shipTypeId = +originShipTypeId
  const { hasWarehouseBarcode } = item
  const omitList = ['id', 'hasWarehouseBarcode', 'rowKey']
  // 進倉用國際條碼 配送方式選擇"快速到貨"時，才出現
  // 或者是選擇系統產生條碼
  if (PRODUCT_SHIP_TYPE.EXPRESS_24HR !== shipTypeId || !hasWarehouseBarcode) {
    omitList.push('warehouseBarcode')
  }
  // 如果"不是"newListing+快速到貨, 或者 進倉名稱總長度小於等於50, 不回存warehouseProductName
  if (!(PRODUCT_SHIP_TYPE.EXPRESS_24HR === shipTypeId && isNewListing) ||
    entireProductName.length <= warehouseProductNameCountLimit) {
    omitList.push('warehouseProductName')
  }
  // 實際國際條碼 當配送方式選擇"ESD"或"電子票券"，則不顯示此欄位
  if (
    PRODUCT_SHIP_TYPE.ESD === shipTypeId ||
    PRODUCT_SHIP_TYPE.E_VOUCHER === shipTypeId
  ) {
    omitList.push('barcode')
  }
  return _.omit(item, omitList)
}

const extractProductAttributes = (transientData = []) => {
  const { withSpecLevel: hasSpecLevel } = determineSpecLevel(transientData.hasSpecLevel)
  const attributes = _.get(transientData, `${getSpecAttributeFieldByLevel(hasSpecLevel)}`, {})
  return _.reduce(attributes, (acc, attr) => {
    const { values = [], name } = attr
    const localValues = _.compact(Array.isArray(values) ? values : [values])
    if (_.isEmpty(name) || _.isEmpty(localValues)) {
      return acc
    }
    acc.push({
      name,
      values: localValues
    })
    return acc
  }, [])
}

const getClusterValues = (activeTransientData, specName) => _.get(
  (activeTransientData.spec || []).find(specItem => _.get(specItem, 'selectedOption.label') === specName),
  'selectedOption.cluster.values',
  [])

const getClusterHasOther = (activeTransientData, specName) => _.get(
  (activeTransientData.spec || []).find(specItem => _.get(specItem, 'selectedOption.label') === specName),
  'selectedOption.cluster.hasOTHER',
  false)

export const getEVoucher = (shipTypeId, formValues) => {
  if (shipTypeId !== PRODUCT_SHIP_TYPE.E_VOUCHER) {
    return {}
  }

  const scopeField = getScopedShipTypeSectionName({ shipType: shipTypeId })
  // 電子票券允許保存期限，帶欄位過去後 transformFormDataToProposalData 會做判斷
  // 年月日欄位有值轉換成天數寫入、沒有值則不帶
  const preserveDaysFields = _.pick(
    _.get(formValues, `${scopeField}.product`),
    ['years', 'months', 'days']
  )
  const eVoucherAttributes = _.flow(
    () => _.get(formValues, `${scopeField}.product.eVoucherAttributes`, {}),
    eVocherFieldValues => _.reduce(eVocherFieldValues, (attrs, value, name) => {
      attrs.push({
        value,
        name
      })
      return attrs
    }, [])
  )()
  const shipType = {
    id: PRODUCT_SHIP_TYPE.ESD,
    model: 150
  }
  const eVoucherType = _.get(formValues, getScopedFieldNameByShipType(shipTypeId, 'product.eVoucherType'))
  const eVoucher = {
    eVoucherAttributes,
    shipType,
    eVoucherType,
    ...preserveDaysFields
  }
  return eVoucher
}

export const extractTransientProduct = (formValues) => {
  const shipTypeId = getShipTypeIdFromAllValues(formValues, true)
  const productName = getProductNameFromAllValues(formValues)
  const isExpiringItem = getIsExpiringItemFromAllValues(formValues)
  const activeTransientData = getActiveTransientData(formValues)
  const { hasSpecLevel } = activeTransientData
  const activeFieldPrefix = `${getAttrTableFieldPrefixByLevel(hasSpecLevel)}`
  const isNewListing = isNewListingProposal(getPropposalTypeFromAllValues(formValues))
  let product = _.get(activeTransientData, activeFieldPrefix, {})
  const eVoucher = getEVoucher(shipTypeId, formValues)
  product = _.omit(product, ['expandedRowKeys', 'eVoucherAttributes'])

  const { shareMediaBetweenModels } = product

  const warehouseProductNameCountLimit = isExpiringItem ? MAX_PRODUCT_NAME_IN_EXPRESS_24HR - EXPIRING_NOTE.STR.length : MAX_PRODUCT_NAME_IN_EXPRESS_24HR
  const productModels = _.map(
    _.get(product, 'models', []),
    model => {
      const {
        shareImageModel,
        images = [],
        rowKey,
        ...restModel
      } = model

      let localImages = images

      if (shareMediaBetweenModels) {
        localImages = shareImageModel
          ? images
          : []
      }

      localImages = _.reduce(
        localImages,
        (acc, image = {}) => {
          const { url, order } = image
          if (url && order) {
            acc.push({ url, order })
          }
          return acc
        }, [])

      const { spec } = restModel
      const specValue = _.get(spec, 'values[0]', '')
      const specName = _.get(spec, 'name', '')
      const modelName = _.get(model, 'displayName', specValue)
      /**
       * 處理 level 1 spec
       * 由於「複製賣場」可能產生spec.values[0]其實不在clusterValue的資料
       * 則以為第一個可選擇項目來取代為specValues
       */
      if (hasSpecLevel) {
        const clusterValues = getClusterValues(activeTransientData, specName)
        if (clusterValues.length > 0) {
          if (!clusterValues.includes(specValue)) {
            // specValue not exist within clusterValues
            // should be replaced with first exist option except hasOTHER is true
            const hasOther = getClusterHasOther(activeTransientData, specName)
            _.set(spec, 'values[0]', hasOther ? OTHER_ATTRIBUTE_VALUE : clusterValues[0])
          }
        }
      }

      const localItems = _.map(
        _.get(model, 'items', []),
        // remove useless state
        item => {
          const itemSpecValue = _.get(item, 'spec.values[0]', '')
          const itemName = _.get(item, 'displayName', itemSpecValue)
          const itemSpecName = _.get(item, 'spec.name', '')
          const clusterValues = getClusterValues(activeTransientData, itemSpecName)
          /**
           * level 2 itemSpecValue checking
           * 「複製賣場」可能產生items[].spec.values[0]其實不在clusterValue的資料
           **/
          if (itemSpecValue !== '' && clusterValues.length > 0) {
            if (!clusterValues.includes(itemSpecValue)) {
              // specValue not exist within clusterValues
              // should be replaced with first exist option except hasOTHER is true
              const hasOther = getClusterHasOther(activeTransientData, itemSpecName)
              _.set(item, 'spec.values[0]', hasOther ? OTHER_ATTRIBUTE_VALUE : clusterValues[0])
            }
          }

          const entireProductName = getEntireProductName(productName, modelName, itemName)
          return omitAttributeTableItem(
            item,
            shipTypeId,
            isNewListing,
            entireProductName,
            warehouseProductNameCountLimit
          )
        }
      )

      /**
       * 無選項時，
       * 把外層供應商商品料號視為內層供應商商品料號
       */
      if (!hasSpecLevel) {
        const productPartNo = _.get(formValues, 'product.partNo', '')
        _.set(localItems, '[0].partNo', productPartNo)
      }

      // [商品屬性]選擇"無選項"，payload should not include proposal.product.specs
      return {
        ...restModel,
        images: _.take(localImages, 10),
        items: localItems
      }
    })

  return {
    ...product,
    ...eVoucher,
    models: productModels,
    attributes: extractProductAttributes(activeTransientData)
  }
}

export const getShipTypeDefaultFormData = () => {
  const {
    NORMAL
  } = PRODUCT_DELIVERY_TYPE
  const formData = {}
  // NOTE: not deleting those value so the structure can be easy to understand in the first look
  // 宅配預設值
  _.set(formData, getScopedShipTypeSectionName({ shipType: '1' }), {
    listing: {
      deliveryType: NORMAL
    }
  })
  // 快速到貨預設值
  _.set(formData, getScopedShipTypeSectionName({ shipType: '61' }), {
    product: {
      // length: '0',
      // width: '0',
      // height: '0',
      // weight: '0',
      isInstallRequired: false,
      isLargeVolumnProductGift: false,
      isOutrightPurchase: false,
      // preserveDays: '0',
      isExpiringItem: false,
      minPackingCount: '1'
    },
    listing: {
      deliveryType: NORMAL,
      customizedOrderShipDateAfterPlaced: null,
      preOrderExpectedShipDate: null
    }
  })
  // 直店配預設值
  _.set(formData, getScopedShipTypeSectionName({ shipType: '800' }), {
    product: {
      // length: '0',
      // width: '0',
      // height: '0',
      // weight: '0'
    },
    listing: {
      deliveryType: NORMAL
    }
  })
  // ESD預設值
  _.set(formData, getScopedShipTypeSectionName({ shipType: '200' }), {
    listing: {
      deliveryType: NORMAL
    }
  })
  return formData
}

/**
 * shipTypeForm 是每一種 shipType 各自獨自子表單，
 * 為了紀錄 user 在不同 shipType 下的不同選項
 */
export const extractShipTypeFormSection = (formData) => {
  const shipTypeId = getShipTypeIdFromAllValues(formData)
  const formSectionName = getScopedShipTypeSectionName({ shipType: shipTypeId })
  const shipTypeFormSection = _.get(formData, formSectionName, {})
  // 單次限購數量(超取) 非直店配則預設1
  // https://thestreet.ouroath.com/docs/DOC-127537
  if (shipTypeId !== PRODUCT_SHIP_TYPE.HOME_STORE) {
    _.set(shipTypeFormSection, 'listing.cvsPurchaseQtyLimit', 1)
  }
  // 新增屬性商品無單次限購數量(宅配), 單次限購數量(超取)
  if (isNewProductProposal(formData.type)) {
    _.set(shipTypeFormSection, 'listing.purchaseQtyLimit', null)
    _.set(shipTypeFormSection, 'listing.cvsPurchaseQtyLimit', null)
  }
  return shipTypeFormSection
}

// 依據SupplierProfile的設定來重設表單數值
export const syncDataBySetting = (setting, data) => {
  const {
    applianceContract,
    outrightPurchaseContract
  } = setting

  const shipTypeId = getShipTypeIdFromAllValues(data)

  let localData = {}
  const localProduct = {}
  const localListing = {}

  // 若為快速到貨
  if (PRODUCT_SHIP_TYPE.EXPRESS_24HR === shipTypeId) {
    // 若無買賣增補附約則將買斷商品欄位設為false
    if (!outrightPurchaseContract) {
      _.set(localProduct, 'isOutrightPurchase', false)
    }

    if (applianceContract) {
      const isInstallRequiredInComingData = _.get(data, 'product.isInstallRequired', false)
      /**
       * 若為快速到貨且勾選需安裝，則交貨期為"客約送貨日"
       */
      if (isInstallRequiredInComingData) {
        _.set(localListing, 'deliveryType', PRODUCT_DELIVERY_TYPE.APPOINTMENT)
      }
    } else {
      /** 若無家電增補附約則將買斷商品欄位設為false */
      _.set(localProduct, 'isInstallRequired', false)
      _.set(localProduct, 'isLargeVolumnProductGift', false)
    }
  }

  localData = { product: localProduct, listing: localListing }

  return _.merge({}, data, localData)
}

// 根據 identity 獲得 applicant
export const syncApplicantByIdentity = (applicant, identity) => {
  // 提案人：
  // 若為"PM 仿供應商登入"，則提案人變更為登入 PM 之中文姓名 (不提供修改)
  // 供應商登入或模擬登入: 維持原提案人
  // 如果身份為 PM 而且沒填提案人則將提案人取代成PM的名字
  if (identity.isPM && _.isEmpty(applicant)) {
    return _.truncate(
      identity.name,
      {
        length: getFieldLengthMaxByName('APPLICANT'),
        omission: ''
      }
    )
  }

  return applicant
}

// 依序身份來重設資料
export const syncDataByIdentity = (setting, data) => {
  const { user } = setting
  const { id, applicant } = data
  const localData = {}
  const identity = _.get(user, 'identity', {})

  // 如果沒有提案編號則重設applicant
  if (!id) {
    _.set(localData, 'applicant', syncApplicantByIdentity(applicant, identity))
  }

  if (!identity.isPM) {
    // 提案人不是PM
    // 移除低毛選項
    _.set(localData, 'listing.applyLowGpm', false)
    // 將顯示賣場設為預設值 true
    _.set(localData, 'listing.isDisplay', true)
  }

  return _.merge({}, data, localData)
}

// 轉換eVoucherAttributes
export const convertEVoucherAttributes = (oldEVoucherAttributes, userEVoucherAttributes) => {
  const eVoucherAttributesMapByName = _.keyBy(oldEVoucherAttributes, 'name')
  const convertedEVoucherAttributes = userEVoucherAttributes.map(userEVoucherAttribute => {
    return {
      value: _.get(eVoucherAttributesMapByName, `${userEVoucherAttribute.name}.value`, ''),
      name: userEVoucherAttribute.name
    }
  })
  return convertedEVoucherAttributes
}

export const setShipTypeFormSectionByFormData = (setting, data) => {
  let formData = data
  // isUIState 是在避免 function 把 shipTypeId 從 200150 轉回 200，因為是 UI 狀態所以不需要轉回去，只有從 UI 狀態變成 API params 時才要把 200150 轉回 200
  const shipTypeId = getShipTypeIdFromAllValues(data, true)
  const formSectionName = getScopedShipTypeSectionName({ shipType: shipTypeId })
  const deliveryTypeField = 'deliveryType'
  _.set(formData, formSectionName, {
    listing: {
      deliveryType: _.get(data, `listing.${deliveryTypeField}`, PRODUCT_DELIVERY_TYPE.NORMAL)
    }
  })
  const eVoucherType = _.get(data, 'product.eVoucherType', RADIO_EVOUCHER_TYPES[0].value)
  // shipTypeFormSection.shipType200150.product 增加eVoucherType 預設為 "ticket" ，UI預設也才會勾選
  _.set(formData, `${getScopedShipTypeSectionName({ shipType: PRODUCT_SHIP_TYPE.E_VOUCHER })}.product.eVoucherType`, eVoucherType)
  _.set(formData, 'product.eVoucherType', eVoucherType)
  const productPickFieldListForExpress24HR = ['length', 'width', 'height', 'weight', 'isInstallRequired', 'isLargeVolumnProductGift', 'isOutrightPurchase', 'preserveDays', 'isExpiringItem', 'minPackingCount']
  const productPickFieldListForHomeStore = ['length', 'width', 'height', 'weight']
  const listingPickFieldListForNotExpress24HR = ['customizedOrderShipDateAfterPlaced', 'preOrderExpectedShipDate']

  const productOmitFieldList = [...productPickFieldListForExpress24HR, ...productPickFieldListForHomeStore]
  const listingOmitFieldList = [deliveryTypeField, ...listingPickFieldListForNotExpress24HR]

  const feature = _.get(setting, 'feature', '')
  const isCloneListing = feature === PROPOSAL_TYPE.CLONE_LISTING
  // 取得當前賣場可渲染eVoucherAttributes格式
  const eVoucherFieldFromUser = _.get(setting, 'user.eVoucherAttributes', [])

  const { product, listing } = formData
  const originEVoucherAttributes = _.get(product, 'eVoucherAttributes', [])
  const localFormData = {}

  switch (shipTypeId) {
    case PRODUCT_SHIP_TYPE.HOME:
    case PRODUCT_SHIP_TYPE.ESD: {
      const localListing = _.pick(listing, listingPickFieldListForNotExpress24HR)
      _.set(localFormData, formSectionName, {
        listing: localListing
      })
      break
    }
    // 電子票券
    // 新增product底下預設值電子票券欄位

    // product: {
    //   shipType: {
    //     id: 200150
    //   },
    //   eVoucherAttributes: [
    //     {
    //       value: '1',
    //       name: 'OrderNumber'
    //     },
    //     {
    //       value: '測試',
    //       name: 'MerchantCode'
    //     },
    //     {
    //       value: '2023-01-31T13:41:59+08:00',
    //       name: 'ProductCode'
    //     }
    //   ],
    //   eVoucherType: 'ticket',
    //   preserveDays: 396
    // }
    case PRODUCT_SHIP_TYPE.E_VOUCHER: {
      let newEVoucherAttributes = originEVoucherAttributes
      // 當在[複製賣場]時，redux form 裡的shipType200150.product.eVoucherAttributes，需與當前賣場需渲染UI user eVoucherAttributes欄位做比對，重組資料推到 redux form
      // 避免 user eVoucherAttributes 電子票券欄位改變後，多出從賣場 skuDetail 組出不應該存在的欄位
      if (isCloneListing) {
        newEVoucherAttributes = convertEVoucherAttributes(originEVoucherAttributes, eVoucherFieldFromUser)
      }
      const eVocherFieldValues = _.flow(
        () => _.reduce(newEVoucherAttributes, (fieldValues, eVoucherAttribute) => {
          const { name, value } = eVoucherAttribute
          fieldValues[name] = value
          return fieldValues
        }, {})
      )()
      const preserveDays = _.toNumber(product.preserveDays)
      let preserveDaysField = { preserveDays: null }
      if (!(_.isNaN(preserveDays) || preserveDays === 0)) {
        // 如果有保存期限就需要將天數轉換成年月日
        preserveDaysField = {
          ...groupDaysByDateType(preserveDays),
          preserveDays
        }
      }
      _.set(localFormData, formSectionName, {
        product: {
          ...product,
          ...preserveDaysField,
          shipType: { id: shipTypeId },
          eVoucherAttributes: eVocherFieldValues
        }
      })
      break
    }
    // 直店配
    case PRODUCT_SHIP_TYPE.HOME_STORE: {
      const localProduct = _.pick(product, productPickFieldListForHomeStore)
      const localListing = _.pick(listing, listingPickFieldListForNotExpress24HR)
      _.set(localFormData, formSectionName, {
        product: localProduct,
        listing: localListing
      })
      break
    }
    // 快速到貨
    case PRODUCT_SHIP_TYPE.EXPRESS_24HR: {
      let localProduct = _.pick(product, productPickFieldListForExpress24HR)
      const preserveDays = _.toNumber(localProduct.preserveDays)
      if (_.isNaN(preserveDays) || preserveDays === 0) {
        localProduct.preserveDays = null
      } else {
        // 如果有保存期限就需要將天數轉換成年月日
        localProduct = _.merge(localProduct, groupDaysByDateType(preserveDays))
      }
      _.set(localFormData, formSectionName, {
        product: localProduct
      })
      break
    }
  }
  // 將修改後的FormSection結果存回
  formData = _.merge({}, formData, localFormData)

  // 將已經取得的欄位移除並且將原始資料不需要欄位也移除
  const nextProduct = _.omit(product, productOmitFieldList)
  const nextListing = _.omit(listing, listingOmitFieldList)
  _.set(formData, 'product', nextProduct)
  _.set(formData, 'listing', nextListing)

  return formData
}

export const getTransientSpecAttributes = transientModel => {
  const { withSpecLevel: hasSpecLevel } = determineSpecLevel(transientModel.hasSpecLevel)
  return _.get(transientModel, getSpecAttributeFieldByLevel(hasSpecLevel), [])
}
export const getClusterAttributes = struDataAttrCluster => _.get(struDataAttrCluster, 'attributes', [])

export const getFinalAttributesForTransient = (transientModel, struDataAttrCluster) => {
  const { spec, hasSpecLevel: originHasSpecLevel } = transientModel
  const { withSpecLevel: hasSpecLevel } = determineSpecLevel(originHasSpecLevel)
  const transientAttributes = getTransientSpecAttributes(transientModel)

  const clusterAttributes = getClusterAttributes(struDataAttrCluster)
  // clusterAttributes 在查無規格表時格式會變成 { [withLevel|withoutLevel]: [attribute] }
  // 預期應該是直接顯示 [attribute]，所以做了兼容萬一格式變更仍能取得 attributes
  const attributesFromStruData = _.isArray(clusterAttributes)
    ? clusterAttributes
    : getTransientSpecAttributes({ attributes: clusterAttributes, hasSpecLevel })
  const attributeNamesFromStruData = _.map(attributesFromStruData, 'name')

  const attributesInSpec = hasSpecLevel
    ? _.compact(
      _.map(
        spec,
        localSpec => {
          const { selectedOption = {} } = localSpec
          const { value } = selectedOption
          return { name: value }
        }
      )
    )
    : []

  // 過濾出自訂屬性
  const customAttributes = _.filter(
    transientAttributes,
    attr => !_.includes(attributeNamesFromStruData, attr.name)
  ) || []

  _.each(
    customAttributes,
    attr => {
      _.set(attr, 'constraints', { type: ATTRIBUTE_CONSTRAINTS_TYPE.CUSTOM })
      return attr
    }
  )

  let attributesInList = _.differenceBy(
    [...attributesFromStruData, ...customAttributes],
    attributesInSpec,
    'name'
  )

  attributesInList = _.map(
    attributesInList,
    attr => {
      const localAttr = removeOTHERFromClusterValues(attr)
      const localAttrValues = _.get(localAttr, 'values', [])
      const hasOTHER = _.get(localAttr, 'hasOTHER', false)

      const options = _.map(localAttrValues, attrValue => ({ label: attrValue, value: attrValue }))

      // 複製上次屬性內已填資料
      const prevAttr = _.find(transientAttributes, { name: localAttr.name }) || {}
      const preAttrValues = _.get(prevAttr, 'values', null)

      /**
       * 規格表中某 attribute 的預設可選 value options 可能會改變，
       * 所以必須檢查提案單中 attribute value 現在是否有有在預設的 attribute value options 中
       *
       * customPreValues 表示：不在預設清單中的 user input values
       */
      const customPreValues = _.filter(
        preAttrValues,
        preAttrValue => !_.includes(localAttrValues, preAttrValue)
      )

      let attrValues = preAttrValues
      const isTextType = _.get(localAttr, 'constraints.type') === ATTRIBUTE_CONSTRAINTS_TYPE.TEXT
      if (!isTextType) {
        const customPreValuesLength = customPreValues.length
        if (
          /**
           * attribute hasOTHER 的話，可以有一個不在預設 options 中的 value
           * attribute 無 hasOTHER, 不可以有不在預設 options 中的 value
           */
          (hasOTHER && customPreValuesLength > 1) ||
          (!hasOTHER && customPreValuesLength > 0)
        ) {
          attrValues = null
        }
      }

      return ({
        ...attr,
        hasOTHER,
        options,
        values: attrValues
      })
    })

  return attributesInList
}

export const ATTR_TRANSIENT_PREFIX = 'attribute'
export const FULL_ATTR_TRANSIENT_KEY = `${TRANSIENT_FIELD_KEY}.${ATTR_TRANSIENT_PREFIX}`

export const getAttrTransientKey = (subStationId, catItemId, struDataAttrClusterId) => {
  const isValidKey = !!((subStationId && struDataAttrClusterId))
  return isValidKey
    ? `${FULL_ATTR_TRANSIENT_KEY}.${subStationId}_${catItemId}_${struDataAttrClusterId}`
    : INVALID_TRANSIENT_KEY
}

/** 取得欄位長度限制，長度限制寫在 shp FIELD_MAX_LENGTH 中 */
export const getFieldLengthMaxByName = fieldName => _.get(FIELD_MAX_LENGTH, fieldName, 25)
/** 計算單次限購數量(超取)的上限值，利用 20000/price 計算 */
export const getCvsQtyLimitMaxByPrice = (price = '') => {
  const priceToNumber = _.toNumber(showOnlyNumber(price))
  const cvsQtyLimit = priceToNumber > 0
    ? Math.floor(20000 / priceToNumber)
    : 1
  return cvsQtyLimit < 1 ? 1 : cvsQtyLimit
}

export const formatUploadedVideoFile = (file) => {
  if (_.isEmpty(file)) {
    return {}
  }
  return _.merge(
    { order: 1, url: '', status: '', thumbnail: null },
    _.omit(file, ['height', 'width', 'duration'])
  )
}

export const fileWithoutCircleProps = file => {
  const convertedFile = _.isNil(file)
    ? file
    // 上傳影片後 submit data video 欄位會包含 httprequest circle
    // 如果觸發 prune 會無限造成 maximum call stack error
    : _.omit(file, ['httprequest'])
  return convertedFile
}

export const getUploadStateByUI = (ui) => ui.getState(MEDIA_UPLOADER_ID) || {}

/**
 * 替 html string 中的 img tag 濾掉所有禁止的inline style
 * 過寬的 img 作等比縮小
 * 如果有 legacy width property 予以保留
 * tag 如果有 width: 0 樣式移除掉 width 樣式
 */
export const withHTMLCheck = (copyString = '') => {
  let trimmedCopy = removeSpaceAndTab(copyString)
  if (trimmedCopy) {
    const $ = cheerio.load(trimmedCopy, null, false)

    // 移除所有禁止的inline style
    _.map(INVALID_STYLES_IMG.split(/\s+/), style => {
      $('img').css(style, '')
    })

    // 檢查所有的 img tag
    $('img').each((position, element) => {
      // 如果有空的 style attribute 則整個移除
      if ($(element).attr('style') === '') {
        $(element).removeAttr('style')
        return
      }

      // resize過大的圖, 如果有height的資訊則等比縮放
      const width = parseInt($(element).css('width'))
      if (!isNaN(width) && width > EDITOR_UPLOADER_MAX_IMAGE_WIDTH_SIZE) {
        $(element).css('width', `${EDITOR_UPLOADER_MAX_IMAGE_WIDTH_SIZE}px`)
        const height = parseInt($(element).css('height'))
        if (!isNaN(height)) {
          const newHeight = parseInt((height / width) * EDITOR_UPLOADER_MAX_IMAGE_WIDTH_SIZE)
          $(element).css('height', `${newHeight}px`)
        }
      }
    })

    trimmedCopy = $.html()
    // tag 如果有 width: 0 樣式移除掉 width 樣式
    trimmedCopy = removeZeroWidthStyleFromHTML(trimmedCopy)
  }

  return trimmedCopy
}

/**
 * 從 API 取得的 videos
 * 只留 url, order 送回給後端，
 * 且目前只取第一部影片
 */
export const withVideoCheck = videos => {
  const firstVideo = _.get(videos, '[0]', null)

  return _.isNull(firstVideo)
    ? []
    : [_.pick(firstVideo, ['url', 'order'])]
}

export const getListingPreviewPage = proposalId => {
  return {
    uri: `/proposal/${PROPOSAL_TYPE.NEW_LISTING}/${PROPOSAL_PHASE_TYPE.PREVIEW}?id=${proposalId}`,
    target: `listing_preview_${proposalId}`
  }
}

export const getUpdateListingPreviewPage = (proposalId, proposalType) => {
  return `/proposal/${PROPOSAL_TYPE.UPDATE_LISTING}/${PROPOSAL_PHASE_TYPE.PREVIEW}?id=${proposalId}&proposalType=${proposalType}`
}

/**
 * 取得完整的進倉標籤名稱
 * {商品名稱}-{第一層屬性(modelName)}-{第二層屬性{itemName}}
 * 有屬性才會多出 '-'
 **/
export const getEntireProductName = (productName, modelName, itemName) => {
  let entireName = productName || ''
  if (!_.isEmpty(modelName)) {
    entireName = `${entireName}-${modelName}` + (!_.isEmpty(itemName) ? `-${itemName}` : '')
  }
  return entireName
}

// APACSMDESK-44393: 提案是newListing + 運送方式是快速到貨 = 商品最後名稱長度保持為放寬前的長度
export const MAX_PRODUCT_NAME_IN_EXPRESS_24HR = getFieldLengthMaxByName('PRODUCT_NAME')
